import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { IBreadcrumb } from '../common/interfaces/IBreadcrumb';
import { ILookup } from '../common/interfaces/ILookup.interface';
import { ILabel } from '../ILabel.model';
import { TranslationService } from '../common/services/translation.service';
import { Router } from '@angular/router';
import { removeIfExists } from '../common/functions/js-linq';
import { ITranslationFieldService } from '../common/interfaces/ITranslationFieldService.interface';
import { CpqTranslationsService } from './cpq-translations.service';
import { TranslationReturnUrl, TranslationField, TranslationValidation } from './cpq-translations.model';
import { NgForm } from '@angular/forms';
import { CpqToastrService } from '../cpq-toastr/cpq-toastr.service';

@Component({
    selector: 'cpq-translations',
    templateUrl: './cpq-translations.component.html',
    providers: [
        CpqTranslationsService
    ],
    styleUrls: ['./cpq-translations.component.scss'],
    standalone: false
})
export class CpqTranslationsComponent implements OnInit {
  @Input('breadcrumbs') breadcrumbs: Array<IBreadcrumb>;
  @Input('headerLabel') headerLabel: ILabel;
  @Input('translationFieldLabel') translationFieldLabel: ILabel;
  @Input('translationField') translationField: TranslationField;
  @Input('returnUrl') returnUrl: TranslationReturnUrl;
  @Input('queryParams') queryParams?: any;
  @Input('translationFieldService') translatationFieldService: ITranslationFieldService;
  @Input('showSaveButton') showSaveButton: boolean;
  @Input('translationValidation') translationValidation: TranslationValidation;

  public dictionaries: Array<ILookup<number, string>>;
  public addNewButtonDisabled = false;
  @ViewChild('form', { static: true }) form: NgForm;

  constructor(
    private toastr: CpqToastrService,
    private translationService: TranslationService,
    private router: Router,
    private service: CpqTranslationsService
  ) { }

  ngOnInit() {
    this.service.getSystemDictionaries().subscribe(dictionaries => {
      this.dictionaries = dictionaries.systemDictionaries.filter(x=> x.id !== dictionaries.defaultDictionaryId);
    });
  }

  public getItems(value) {
    const availableDictionaries = [...this.dictionaries];
    this.translationField.mlValues.forEach(translation => {
      removeIfExists(availableDictionaries, x => +x.id === translation.id && translation.id !== value.id);
    });
    return availableDictionaries;
  }

  public addTranslation() {
    this.addNewButtonDisabled = true;
    this.translationField.mlValues.push(new ILookup<number, string>());
  }

  public removeTranslation(value?: ILookup<number, string>) {
    if (value.id) {
      removeIfExists(this.translationField.mlValues, x => x.id === value.id);
      this.isTranslationEntered();
    } else {
      this.translationField.mlValues.pop();
      this.addNewButtonDisabled = false;
    }
  }

  public isTranslationEntered() {
    if(this.translationField.mlValues.length === 0){
      this.addNewButtonDisabled = false;
    }else {
      const lastTranslation = this.translationField.mlValues[this.translationField.mlValues.length - 1];
      if (!lastTranslation.id || !lastTranslation.text) {
        this.addNewButtonDisabled = true;
      } else {
        this.addNewButtonDisabled = false;
      }
    }
  }

  public save(goBack: boolean = false) {
    this.translatationFieldService.saveTranslations(this.translationField).subscribe(() => {
      if (goBack) {
        this.router.navigate([this.returnUrl.getReturnUrl()], { queryParams: this.queryParams});
      }
      this.toastr.success(this.translationService.translate('Actions.GenericAction.SaveSuccess'));
    });
  }

  public trackByFn(index: number, item: ILookup<number, string>) {
    return item.id;
  }

}
